/* eslint-disable jsx-a11y/label-has-associated-control */
import React, {useState } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

import { categoriesArrayPropTypes } from 'helpers/propTypes';

import './Menu.scss';

const Menu = (props) => {
  const {
    categories, closeMenu, isMobile, ulClassName,
  } = props;

  const renderProductsMobile = () => (
    <div className="products-menu-mobile" data-testid="nav-products-mobile">
      <div>
        <NavLink to="/productos" activeClassName="active" onClick={closeMenu} data-testid="nav-products">
          Categorias
        </NavLink>
        <label htmlFor="products-menu-mobile-checkbox-0" className="products-menu-mobile-toggle">
          <i className="fa fa-angle-down" />
        </label>
      </div>
      <input type="checkbox" id="products-menu-mobile-checkbox-0" />
      <ul className="products-sub-menu-mobile">
        {categories.map((category) => (
          <li key={`category-${category.id}-mobile`}>
            <NavLink activeClassName="active" onClick={closeMenu} to={`/productos/${category.code}`}>
              {category.name}
            </NavLink>
          </li>
        ))}
      </ul>
    </div>
  );

  const itemsPerPage = Math.ceil(categories.length / Math.ceil(categories.length / 8));
  const totalPages = Math.ceil(categories.length / itemsPerPage);
  const [currentPage, setCurrentPage] = useState(0);
  
  const handleNext = () => {
    setCurrentPage((prevPage) => (prevPage + 1) % totalPages);
  };

  const handlePrevious = () => {
    setCurrentPage((prevPage) => (prevPage - 1 + totalPages) % totalPages);
  };

  const getPageCategories = () => {
    const startIndex = currentPage * itemsPerPage;
    return categories.slice(startIndex, startIndex + itemsPerPage);
  };

  const renderMenu = () => {
    return(
      <div>
        <ul className='menu-items'>
          <li>
            <NavLink
              activeClassName="active"
              onClick={closeMenu}
              to={`/home`}
            >
              Home
            </NavLink>
          </li>
          <li > 
            <NavLink
              activeClassName="active"
              to={`/productos`}
            > 
              Productos
            </NavLink>
          </li>
        </ul>
        <ul className={`category-dropdown`}>
          <button
            onClick={handlePrevious}
            style={{zIndex: 1}}>
            &lt;
          </button>
          <div className='categories-list-menu'>
            {visibleCategories.map((category) => (
              <li key={`category-${category.id}`}>
                <NavLink
                  activeClassName="active"
                  className="category-item"
                  onClick={closeMenu}
                  to={`/productos/${category.code}`}
                >
                  {category.name}
                </NavLink>
              </li>
            ))}
          </div>
          <button
            onClick={handleNext}
            style={{zIndex: 1}}>
            &gt;
          </button>
        </ul>
    </div>
  )
  };


  const visibleCategories = getPageCategories();

  return (
    <ul className={ulClassName} data-testid="menu">
      <li className="products-menu-link">
        {!isMobile && (
            <div className="category-list">
              {renderMenu()}             
          </div>
        )}
        {isMobile && renderProductsMobile()}
      </li>
    </ul>
  );
};

Menu.defaultProps = {
  isMobile: false,
};

Menu.propTypes = {
  categories: categoriesArrayPropTypes.isRequired,
  closeMenu: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
  ulClassName: PropTypes.string.isRequired,
};

export default Menu;
